import React from 'react';
import styles from './styles.module.scss';
import cn from 'classnames';

const Text = ({ className, fontSize, fontWeight, lineHeight, style, children, ...props }) => (
  <div
    className={cn(styles.text, className, props.styles)}
    style={{ ...style, fontSize, fontWeight, lineHeight }}
    {...props}
  >
    {children}
  </div>
);

export default Text;
